import { useQuery } from "@tanstack/vue-query"
import { explorerApi } from "~/api/client"
import type { NexonLwOverviewInfo } from "~/api/repository/models/NexonLwOverviewInfo"
import { setCommaWithDigits } from "~/utils/numberFormat"

export const getLivewatchOverview = () => {
    return useQuery({
        queryKey: ['livewatchOverview'],
        queryFn: () => explorerApi.lwController.getOverview({
            requestBody: {
                assetSymbol: 'NEXON',
            }
        }).then(res => livewatchOverviewDto(res))
    })
}

export type LivewatchOverview = {
  name: string;
  symbol: string;
  circulatingSupply: string;
  maxSupply: string;
  marketCap: string;
  fullyDilutedValue: string;
  dataSourceType: NexonLwOverviewInfo.DSTP;
  lastUpdated: number;
  image: string;
  unlockedProgressPercent: string;
}

const livewatchOverviewDto = (overview: NexonLwOverviewInfo): LivewatchOverview => {
    return {
        name: overview.NM,
        symbol: overview.SB,
        circulatingSupply: setCommaWithDigits(overview.CS, 2),
        maxSupply: setCommaWithDigits(overview.MS, 2),
        marketCap: setCommaWithDigits(overview.MC, 2),
        fullyDilutedValue: setCommaWithDigits(overview.FDV, 2),
        dataSourceType: overview.DSTP,
        lastUpdated: overview.LSTUPD * 1000,
        image: overview.IMG,
        unlockedProgressPercent: setCommaWithDigits(overview.UNLPRGPER, 2),        
    }
}
